<template>
  <router-view />
</template>

<script>
export default {
  name: 'Eingangsrechnungen',
};
</script>

<style></style>
